var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2f76c690fdd3c42b8b4ab8905ad8a7d2145ab0a3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["home-waste-web@clearabee"]={id:"2f76c690fdd3c42b8b4ab8905ad8a7d2145ab0a3"};
      